/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { Sample, Transport } from './transport.model';
import { IWorkflow } from './workflow.model';

export enum DiscrepancyType {
  MissingSample,
  AdditionalSample,
  TransportIssue,
  SampleIssue,
}

export enum DiscrepancyReason {
  WrongSampleAmount,
  WrongSampleType,
  PossibleTampering,
  Other,
}

export enum BagStatus {
  Created,
  SentToFinalDestruction,
  SentToInvestigation,
  Processed,
}

export enum ReviewStatus {
  True,
  False,
  NotApplicable,
}

export interface BlueCheckBag extends IWorkflow {
  discrepancyType: DiscrepancyType;
  discrepancyReason?: DiscrepancyReason;
  bagIdentifier: string;
  sample?: Sample;
  transport: Transport;
  bagStatus: BagStatus;
  wasteReviewed: ReviewStatus;
  transportReviewed: ReviewStatus;
  blueCheckReviewed: ReviewStatus;
  collectionDate: string;
  collectionUserId: number;
  collectionUserName: string;
  reviewDate?: string;
  reviewUserId?: number;
  reviewUserName?: string;

  // lightweight bcb summary
  transportUserName: string;
  transportLocationName: string;
  wastingUserName?: string;
  wastingLocationName?: string;
}

export interface QueryBlueCheckBagsRequest {
  startingIndex: number;
  numberOfRecords: number;
  searchString?: string;
  bagStatus?: BagStatus;
  collectionStartDate?: string;
  collectionEndDate?: string;
}
